import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiSettings } from 'react-icons/fi';
import api from '../services/api';
import './Admin.css';

function AdminLoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError('請輸入帳號與密碼');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await api.adminLogin(username, password);
      navigate('/admin');
    } catch (err) {
      setError(err.message || '登入失敗');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <form className="admin-login-card" onSubmit={handleSubmit}>
        <h1 className="admin-login-title"><FiSettings style={{ marginRight: 10, verticalAlign: 'middle' }} />後台管理系統</h1>
        <p className="admin-login-subtitle">Lucky Wheel Admin</p>

        {error && <div className="admin-error">{error}</div>}

        <div className="admin-form-group">
          <label>帳號</label>
          <input
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            placeholder="請輸入管理員帳號"
            disabled={loading}
            autoComplete="username"
          />
        </div>

        <div className="admin-form-group">
          <label>密碼</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="請輸入密碼"
            disabled={loading}
            autoComplete="current-password"
          />
        </div>

        <button type="submit" className="admin-btn-primary" disabled={loading}>
          {loading ? '登入中...' : '登入'}
        </button>
      </form>
    </div>
  );
}

export default AdminLoginPage;
